module.exports = __webpack_public_path__ + "img/ic-dashboard.5d63110a.svg";